import React from 'react';
import clsx from 'clsx';
import ErrorMessage from './ErrorMessage';

const NotFound = ({ className }) => (
  <ErrorMessage
    className={clsx('modal-message aridhia-not-found', className)}
    error={{ title: 'panel.not.found', message: 'panel.close', translation: { on: true } }}
    icon="ban"
  />
);

export default NotFound;
